module.exports = __webpack_public_path__ + "img/404.c2d2eb4d.png";